import React, { useContext, useEffect } from "react"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import Palette from "../../../components/palette/palette"
import { programmeContext } from "../../../contexts"
import Button from "../../../components/button/button"

const TemoinNavigationContent = ({currentFloor, setCurrentFloor, interactivTemoin, setInteractivTemoin}) => {

  // Functions
  const getTemoin = (list, value, key = "urlName") => {
    return (
      list.find(elem => elem[key] === value) ||
      list[0]
  )}

  // Properties
  const { currentInt } = useParams()
  const { search } = useLocation()
  const navigate = useNavigate()
  const programmeDatas = useContext(programmeContext)
  const temoinsDatas = programmeDatas.pagesDetails.interieurs2.temoins
  const currentTemoin = getTemoin(temoinsDatas, currentInt)
  const [searchParams] = useSearchParams()

  useEffect(() => {
    
    document.getElementById("floor").style.display = "none"
    setCurrentFloor("")
    setTimeout(() => {
      setCurrentFloor("etage0")
      document.getElementById("floor").style.display = "flex"
    }, 10)


    // interactif on && nouveau lot non interactif
    if (interactivTemoin && !currentTemoin.interactiv0) {
      setInteractivTemoin(false)
    }

    // interactiv off && nouveau lot non rotatif
    if (!interactivTemoin && !currentTemoin.nbFrame) {
      setInteractivTemoin(true)
    }

    // force retour 360 si les deux
    if (currentTemoin.nbFrame && currentTemoin.interactiv0) {
      setInteractivTemoin(false)
    }

  }, [currentInt])

  if (!currentTemoin) {return}

  const palette = currentTemoin.typeOf === "simplex" ? ["Niveau 0"] : currentTemoin.typeOf === "duplex" ? ["Niveau 1", "Niveau 0"] : ["Niveau 2", "Niveau 1", "Niveau 0"]





  return (
    <div style = {{
      display: 'flex',
      gap: '40px',
      flexDirection: 'column'
    }}>
      {!searchParams.get("isolate") &&
        <Palette
          list={temoinsDatas.map(item => item.displayName)}
          current={currentTemoin.displayName}
          setCurrent={e => {
            const target = getTemoin(temoinsDatas, e, "displayName").urlName
            navigate( 
              `/${programmeDatas.urlName}/interieurs/temoins/${target}${search}`
            )
            return e
          }
          }
        ></Palette>
    }

      {currentTemoin.interactiv0 && currentTemoin.nbFrame !== 0 &&
        <Button text = "Informations" icon = "info" displayText = "no-hover" state = {interactivTemoin} action = {e => setInteractivTemoin(i => !i)}></Button>
      }

      <div id = "floor">
        {currentTemoin.typeOf !== "simplex" &&
          <Palette 
            list={palette}
            current = {currentFloor.replace("etage", "Niveau ")}
            setCurrent={e => {
              if (e === "Niveau 0") {setCurrentFloor("etage0")}
              else if (e === "Niveau 1") {setCurrentFloor("etage1")}
              else if (e === "Niveau 2") {setCurrentFloor("etage2")}
            }}  
          />}
      </div>
    </div>
  )
}

export default TemoinNavigationContent
